import { Mail, MessagesSquare } from 'lucide-react';

export type ContactChannelFilter = 'ALL' | 'TELEGRAM' | 'MAX' | 'EMAIL';

function TelegramMark() {
  return <svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M20.7 3.5 2.9 10.35c-1.21.49-1.2 1.16-.22 1.46l4.57 1.43 1.75 5.4c.21.58.1.81.72.81.48 0 .69-.22.96-.48l2.19-2.13 4.55 3.36c.84.46 1.44.22 1.65-.78l2.99-14.08c.31-1.23-.47-1.79-1.35-1.44ZM8 12.91l10.73-6.77c.53-.32 1.02-.15.62.2l-8.86 8-.35 3.73L8 12.91Z" /></svg>;
}

export function ChannelMark({ provider }: { provider: string }) {
  const normalized = provider.toUpperCase();
  if (normalized === 'MAX') return <span className="contact-channel-mark contact-channel-mark--max" aria-hidden="true"><img src="/channel-icons/max.png" alt="" /></span>;
  if (normalized === 'TELEGRAM') return <span className="contact-channel-mark contact-channel-mark--telegram" aria-hidden="true"><TelegramMark /></span>;
  if (normalized === 'EMAIL') return <span className="contact-channel-mark contact-channel-mark--email" aria-hidden="true"><Mail /></span>;
  return <span className="contact-channel-mark contact-channel-mark--other" aria-hidden="true"><MessagesSquare /></span>;
}

function customerInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '—';
  return parts.slice(0, 2).map(part => part[0]?.toLocaleUpperCase('ru-RU')).join('');
}

export function ConversationAvatar({ provider, name }: { provider: string; name: string }) {
  return <span className="contact-center-v3-avatar" aria-label={`${name}, канал ${provider}`}>
    <span className="contact-center-v3-avatar__initials" aria-hidden="true">{customerInitials(name)}</span>
    <span className="contact-center-v3-avatar__badge"><ChannelMark provider={provider} /></span>
  </span>;
}

const FILTERS: Array<{ value: ContactChannelFilter; label: string }> = [
  { value: 'ALL', label: 'Все' },
  { value: 'TELEGRAM', label: 'Telegram' },
  { value: 'MAX', label: 'MAX' },
  { value: 'EMAIL', label: 'Email' },
];

export function ChannelFilters({ value, onChange }: { value: ContactChannelFilter; onChange: (value: ContactChannelFilter) => void }) {
  return <div className="contact-channel-filters" role="group" aria-label="Фильтр по каналам">
    {FILTERS.map(filter => <button
      type="button"
      key={filter.value}
      className={filter.value === value ? 'active' : undefined}
      aria-pressed={filter.value === value}
      onClick={() => onChange(filter.value)}
    >{filter.value === 'ALL' ? <span className="contact-channel-filters__all"><MessagesSquare /></span> : <ChannelMark provider={filter.value} />}<span>{filter.label}</span></button>)}
  </div>;
}
